import React, { useState } from "react";
import MobileDisclosure from "./MobileDisclosure";
import { useDispatch, useSelector } from "react-redux";
import { changeBonusMe, giftBoolean } from "../redux/slices/navSlice";
import AccountForms from "./AccountForms";
import RecipientForm from "./RecipientForm";
import Or from "./Or";
import numeral from "numeral";
import ExpressCheckout from "./ExpressCheckout";
import KeepCredit from "./KeepCredit";
import MyCheckoutForm from "./MyCheckoutForm";

const Cart = ({ paymentRequest, isAgreeAllChecked, setIsAgreeAllChecked }) => {
  const nav = useSelector((state) => state.nav);
  const gift = useSelector((state) => state.nav.gift);
  const ikPass = useSelector((state) => state.nav.ikPass);
  const ikPassSingle = useSelector((state) => state.nav.ikPassSingle);
  const isSubscription = useSelector((state) => state.nav.subscription);
  const [openModal, setOpenModal] = useState(false);
  const curSubscriptionTier = useSelector(
    (state) => state.nav.curSubscriptionTier,
  );
  const presenter = useSelector((state) => state.company.presenter);
  const country =
    useSelector((state) => state.company.presenter.country_code) ??
    useSelector((state) => state.company.presenter.data_country);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const isFreeSubscription =
    isSubscription &&
    !!curSubscriptionTier.number_of_free_months &&
    curSubscriptionTier.number_of_free_months > 0;
  const total_due = numeral(presenter.total_due).format("$0,0[.]00");
  const credit_to_give = numeral(presenter.credit_to_give).format("$0,0[.]00");
  const bonus_credit = numeral(presenter.bonus_credit).format("$0,0[.]00");
  const passType = new URLSearchParams(window.location.search).get(
    "utm_content",
  );
  const [subscriptionNum, setSubscriptionNum] = React.useState(1);
  const isSubscriber = false;
  const displayTerms = () => {
    return country !== "US";
  };
  React.useEffect(() => {
    if (
      (presenter.force_gifting && !ikPassSingle) ||
      presenter.prefers_gifting
    ) {
      dispatch(giftBoolean(true));
    }
    if (presenter.bonus_credit === "$0.00") {
      dispatch(changeBonusMe());
    }
  }, []);

  React.useEffect(() => {
    setSubscriptionNum(subscriptionNum + 1);
  }, [curSubscriptionTier]);

  return (
    <div className="cart-column checkout-base-font">
      {!!isSubscription ? null : (
        <div className="inner-col">
          <div className="checkout-head">Cart</div>
          <MobileDisclosure />
          <div className="pay-rectangle checkout-desktop">
            <div className="inner ">
              <span className="font-bold ">
                {presenter.bonus_credit === "$0.00" ? (
                  `${total_due} E-Gift Card`
                ) : !ikPassSingle ? (
                  <span>
                    Pay {total_due}, Get {credit_to_give} ({bonus_credit}
                    {presenter.has_open_amount_options &&
                    presenter.open_amount_bonus !== "Bonus"
                      ? " Discount"
                      : " Bonus"}
                    )
                  </span>
                ) : (
                  <span>
                    {passType === "pg"
                      ? `Pay ${total_due}, Get ${credit_to_give} (${bonus_credit} FREE)`
                      : `Get ${credit_to_give} For ${total_due} (${bonus_credit} FREE)`}
                  </span>
                )}
              </span>
            </div>
          </div>
          <div className="send-to-col">
            {((!presenter.disable_gifting &&
              !presenter.force_gifting &&
              !ikPass) ||
              (!!ikPassSingle && !isSubscription)) && (
              <div className="button-grid ">
                {presenter.prefers_gifting ? (
                  <>
                    {" "}
                    <button
                      onClick={() => dispatch(giftBoolean(true))}
                      className={`choice  ${gift && "selected font-bold"}`}
                    >
                      Send as Gift
                    </button>{" "}
                    <button
                      onClick={() => dispatch(giftBoolean(false))}
                      className={`choice ${!gift && "selected font-bold"}`}
                    >
                      For Yourself
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      onClick={() => dispatch(giftBoolean(false))}
                      className={`choice ${!gift && "selected font-bold"}`}
                    >
                      For Yourself
                    </button>
                    <button
                      onClick={() => dispatch(giftBoolean(true))}
                      className={`choice  ${gift && "selected font-bold"}`}
                    >
                      Send as Gift
                    </button>
                  </>
                )}
              </div>
            )}
            {displayTerms() && (
              <div className="terms">
                By continuing you agree to our{" "}
                <a
                  href="https://inkind.com/terms"
                  className="linker"
                  target="_blank"
                >
                  Terms of Service
                </a>{" "}
                &{" "}
                <a
                  href="https://inkind.com/privacy"
                  className="linker"
                  target="_blank"
                >
                  Privacy Policy
                </a>
              </div>
            )}
          </div>
        </div>
      )}
      {gift && presenter.bonus_credit != "$0.00" && <KeepCredit />}
      {!gift &&
        !user.user &&
        user.loadingUser &&
        !isSubscriber != "pending" &&
        !isFreeSubscription && (
          <ExpressCheckout
            subscriptionNum={subscriptionNum}
            displayButtonOnly={!!JSON.parse(user.user) || !!isAgreeAllChecked}
          />
        )}
      {!gift ? (
        <AccountForms
          bonusCredit={bonus_credit}
          isAgreeAllChecked={isAgreeAllChecked}
          setIsAgreeAllChecked={setIsAgreeAllChecked}
          country={country}
        />
      ) : (
        <RecipientForm userInfo={JSON.parse(user.user)} />
      )}
      {user.user && !gift && (
        <MyCheckoutForm isAgreeAllChecked={isAgreeAllChecked} />
      )}
    </div>
  );
};

export default Cart;
